import React, { Component } from "react";

import { connect } from "react-redux";

import downloadFAFBreportMiddleware from "../../../store/middleware/downloadFAFBreportMiddleware";
import ForcastReportMiddleware from "../../../store/middleware/forcastReportMiddleware";
import CategoryMiddleware from "../../../store/middleware/categoryMiddleware";
import DownloadIcon from "../../../assets/images/downloadIcon.svg";
import Downloading from "../../../assets/gifs/Downloading.gif";


import StandPointMiddleware from '../../../store/middleware/standpointMiddleware'
import CoreTypeMiddleware from '../../../store/middleware/coretypeMiddleware'
import SegmentMiddleware from "../../../store/middleware/segmentMiddleware";
import BrandsMiddleware from "../../../store/middleware/brandsMiddleware";
import RegionsMiddleware from '../../../store/middleware/regionMiddleware'
import SkusMiddleware from "../../../store/middleware/skusMiddleware";
import CustomSelect from "../../../components/common/select/Select";
import { compare } from "../../../prat_screen/gt/validation/sort";
import CustomToast from '../../../util-functions/customToast.jsx'
import { Loader } from "../../../components/loader";
import "../../../assets/style/forcast.style.scss";
import Button from "@material-ui/core/Button";
import MonthlyReport from "./MonthlyReport";
import WeeklyReport from "./WeeklyReport";
// import { dummyData } from './dummydata'
import YTDReport from "./YTDReport";

class ForecastAccuracyAnalyticsReport extends Component {
  constructor() {
    super();
    this.state = {
      myTempSkus: [],
      myTempBrands: [],
      myBrands: [],
      mySkus: [],
      region: [],
      years: [{ value: (new Date().getFullYear())-1, label: (new Date().getFullYear())-1 }, { value: new Date().getFullYear(), label: new Date().getFullYear() }],
      reportType: [{ value: 1, label: 'Weekly' }, { value: 2, label: 'Monthly' }, { value: 3, label: 'YTD' }],
      graphType: [{ value: 1, label: 'Primary' }, { value: 2, label: 'Secondary' }],
      selectedCategory: [],
      selectedBrand: [],
      selectedSku: [],
      selectedRegion: [],
      selectedSegment: [],
      selectedReportType: [{ value: 1, label: 'Weekly' }],
      selectedGraphType: [{ value: 1, label: 'Primary' }],
      selectedCoreType: [],
      selectedStandPoint: [],
      selectedIntervention: [{ value: "Machine", label: "Machine" }],
      switchFlag: true,
      selectedForecast: true,
      isLoadingInitial: true,
      selectedYear: [{ value: (new Date().getFullYear())-1, label: (new Date().getFullYear())-1 }],
      currentSelectedType: [{ value: 1, label: 'Weekly' }],
      selectedActiveStatus: [{ value: 3, label: "All" }],
      isVolumeOptions: [{ value: true, label: 'Case' }, { value: false, label: 'Tons' }],
      selectedIsVolume: [{ value: false, label: 'Tons' }],
      cutsOptions: [4, 8, 13, 26, 52],
      selectedCut: 4,
      selectAllMSKU: false
    };
  }

  componentDidMount() {
    if (!navigator.onLine) {
      // ToastsStore.error("You are Offline");
      CustomToast('error', 'You are Offline')
      return;
    }
    // await this.fetchAll()
    // await this.getDataOnComponentMount();
    setTimeout(() => {
      this.props.getCategory();
      this.props.getBrands();
      this.props.getSkus();
      this.props.getRegions()
      this.props.getStandPoint()
      this.props.getCoreType()
      // setTimeout(() => {
      //   this.getDataOnComponentMount();
      // }, 2000);
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {

    if ((prevProps.category !== this.props.category) || (prevProps.category === this.props.category)) {
      if (prevProps.standpoints !== this.props.standpoints && this.props.category?.length) {
        this.getDataOnComponentMount();
      }
    }

    if (prevProps.brands !== this.props.brands) {
      this.getBrands();
    }
  }

  getDataOnComponentMount = () => {
    this.setState(
      {
        selectedCategory: [this.props.category[0].guid],
        selectedStandPoint: [this.props.standpoints ? this.props.standpoints[this.state.selectedYear[0].value][this.props.standpoints[this.state.selectedYear[0].value].length - 1] : '']
      },
      () => {
        if (this.props?.brands) {
          this.getBrands();
        }
        this.props.postForcastAccuracyV2Analytics(
          this.state.selectedCategory,
          this.state.selectedBrand,
          this.state.selectedSku,
          this.state.selectedRegion,
          this.state.selectedReportType,
          this.state.selectedGraphType,
          this.state.selectedYear,
          this.state.selectedCoreType,
          this.state.selectedStandPoint,
          this.state.selectedIntervention,
          this.state.selectedActiveStatus,
          this.state.selectedIsVolume,
          this.state.selectedCut,
          this.state.selectAllMSKU
        );
        this.setState({ isLoadingInitial: false });
      }
    );
  };

  getBrands = () => {
    try {
      // setTimeout(() => {
      const {
        selectedCategory,
      } = this.state;
      const { brands } = this.props;
      let filteredbrands = [];
      if (selectedCategory.length) {
        // alert('hello')
        for (let i = 0; i < selectedCategory.length; i++) {
          filteredbrands.push(
            ...brands.filter((item) => {
              return item.Category === selectedCategory[i];
            })
          );
        }
      }
      this.setState(
        {
          myBrands: filteredbrands,
        },
        () => {
          let selectBrands = [];
          this.state.myBrands.length &&
            this.state.myBrands.forEach((item) => selectBrands.push(item.guid));
          // console.log("display ids", selectBrands);
          this.setState({
            selectedBrand: selectBrands,
          });
        }
      );
      this.getSkus();
      // }, 600);
    } catch (error) { }
  };

  getSkus = () => {
    setTimeout(() => {
      const { selectedBrand } = this.state;
      // console.log("SEL BRAND", selectedBrand);
      const { skus } = this.props;
      // console.log("SEL BRAND", skus.Brand);
      let filteredSkus = [];
      if (selectedBrand.length) {
        // alert("hekko");
        for (let i = 0; i < selectedBrand.length; i++) {
          filteredSkus.push(
            ...skus.filter((item) => {
              return item.Brand === selectedBrand[i];
            })
          );
        }
      }
      this.setState({
        mySkus: filteredSkus,
      });
    }, 4000);
  };


  handleFilteredSkus = () => {
    const { selectedBrand, selectedSku } = this.state;
    // console.log("SEL BRAND", selectedBrand);
    const { skus } = this.props;
    // console.log("SEL BRAND", skus.Brand);
    let filteredSkus = [];
    if (selectedBrand.length) {
      // alert("hekko");
      for (let i = 0; i < selectedBrand.length; i++) {
        filteredSkus.push(
          ...skus.filter((item) => {
            return item.Brand === selectedBrand[i];
          })
        );
      }

      let arr = [];
      if (selectedSku.length) {
        filteredSkus.forEach(item => {
          if (selectedSku.includes(item.Code)) {
            arr.push(item.Code)
          }
        })
        this.setState({ selectedSku: arr });
      }

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChangeCategory = (selectedValue) => {
    // console.log(`%c VALUE  ${selectedValue}`, "color:dodgerblue");
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      // alert("hello");
      this.setState({
        selectedCategory: [],
        myBrands: [],
        selectedBrand: [],
        selectedSku: [],
        mySkus: [],
      });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("ARR", arr);

      // if (arr == null) {
      //   console.log(
      //     `%c deletion process 1  ${this.state.myBrands.value}`,
      //     "color:dodgerblue"
      //   );
      // } else {
      //   console.log(
      //     `%c deletion process 1 else  ${this.state.myBrands.value}`,
      //     "color:dodgerblue"
      //   );
      // }

      this.setState({ selectedCategory: arr }, () => {
        this.getBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    // console.log("VALUE", selectedValue);
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({ selectedBrand: [], selectedSku: [], mySkus: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedBrand: arr }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleRegion = (selectedValue) => {
    // console.log("VALUE", selectedValue);
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedRegion: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("REGION", arr);
      this.setState({ selectedRegion: arr });
    }
  };

  handleSkus = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedSku: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedSku: arr,
         selectAllMSKU: selectedValue.length === this.state.mySkus.length ? true : false
        });
    }
  };
  handleSegment = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedSegment: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("SKUS", arr);
      this.setState({ selectedSegment: arr });
    }
  };

  handleCallSubmit = async () => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedReportType,
      selectedGraphType,
      selectedYear,
      selectedCoreType,
      selectedStandPoint,
      selectedIntervention,
      selectedActiveStatus,
      selectedIsVolume,
      selectedCut,
      selectAllMSKU
    } = this.state;
    let data = {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedReportType,
      selectedGraphType,
      selectedYear,
      selectedCoreType,
      selectedStandPoint,
      selectedIntervention,
      selectedActiveStatus,
      selectedIsVolume,
      selectedCut,
      selectAllMSKU
    };
    // console.log("data", data)
    await this.handleSubmitFN(data);
  };

  handleSubmitFN = async (data) => {
    // console.log('submit')
    await this.props.postForcastAccuracyV2Analytics(
      data.selectedCategory,
      data.selectedBrand,
      data.selectedSku,
      data.selectedRegion,
      data.selectedReportType,
      data.selectedGraphType,
      data.selectedYear,
      data.selectedCoreType,
      data.selectedStandPoint,
      data.selectedIntervention,
      data.selectedActiveStatus,
      data.selectedIsVolume,
      data.selectedCut,
      data.selectAllMSKU
    );
    this.setState({ currentSelectedType: data.selectedReportType })
  };

  reportTypehandle = (value) => {
    this.setState({ selectedReportType: [value] })
  }

  hanldeGrapgType = (value) => {
    this.setState({ selectedGraphType: [value] })

  }

  hanldeIsVolume = (value) => {
    this.setState({ selectedIsVolume: [value] })
  }

  handleCutChange = value => {
    this.setState({
      selectedCut: value.value
    })
  }

  handleYear = (e) => {
    this.setState({ selectedYear: [e], selectedStandPoint: [] })
  }

  handleCoreType = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedCoreType: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("REGION", arr);
      this.setState({ selectedCoreType: arr });
    }
    // this.setState({ selectedCoreType: [e.value] })
  }

  handleStandPoint = (e) => {
    this.setState({ selectedStandPoint: [e.value] })
  }

  handleIntervention = (e) => {
    this.setState({ selectedIntervention: [e] })
  }

  handledActiveStatus = (e) => {
    this.setState({ selectedActiveStatus: [e] })
  }

  handleDownload = (e) => {
    e.preventDefault();
    this.props.downloadXlx(
      this.state.selectedCategory,
      this.state.selectedBrand,
      this.state.selectedSku,
      this.state.selectedRegion,
      this.state.selectedReportType,
      this.state.selectedGraphType,
      this.state.selectedYear,
      this.state.selectedCoreType,
      this.state.selectedStandPoint,
      this.state.selectedIntervention,
      this.state.selectedActiveStatus,
      this.state.selectedIsVolume,
      this.state.selectedCut,
      this.state.selectAllMSKU
    );
  };

  render() {
    const {
      forecastReportAccuracy,
      category,
      coretype,
      standpoints,
      regions,
      isCategoryLoading,
    } = this.props;
    // console.log("forecastReportAccuracy =>", forecastReportAccuracy);
    // console.log("coretype =>", coretype);
    // console.log("standpoints =>", standpoints);
    // console.log("standpoints =>", this.state.selectedCoreType);
    if (!category) {
      return <Loader flag={isCategoryLoading} />;
    } else {
      return this.props.isForcastAccuracyLoading ? (
        <Loader flag={this.props.isForcastAccuracyLoading} />
      ) : this.props.forecastReportAccuracy === undefined ? (
        <Loader flag={this.state.isLoadingInitial} />
      ) : (
        // return 
        <>
          <div className="page-container">
            <div className="heading-and-download-container">
              <span className="component-heading">Forecast Accuracy / Forecast Bias</span>
              {this.state.selectedReportType[0].label !== 'YTD' ?
                <>
                  {this.props.isFileDownloading ? (
                    <img
                      src={Downloading}
                      style={{ width: "26px", height: "31px" }}
                      alt=''
                    />
                  ) : (
                    <img
                      src={DownloadIcon}
                      onClick={this.handleDownload}
                      className="download-xlx-img"
                      alt="xldownload"
                    />
                  )}
                </>
                : null}
            </div>
            <div className="forcast-accuracy-main-contaier">
              <div className="select-container">
                <div className="filters-container-only">
                  <CustomSelect.MyCustomSelect
                    placeholder={"Category"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      category
                        ? category.sort(compare).map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                        : []
                    }
                    onChange={this.handleChangeCategory}
                    value={category
                      .filter((item) => {
                        return this.state.selectedCategory.includes(item.guid);
                      })
                      .map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })}
                  />
                  {/* )} */}
                  <CustomSelect.MyCustomSelect
                    placeholder={"Brands"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      this.state.myBrands
                        ? this.state.myBrands.sort(compare).map((item) => ({
                          value: item.guid,
                          label: item.Name,
                        }))
                        : []
                    }
                    // defaultValue={this.state.myBrands[0]}
                    onChange={this.handleBrandChange}
                    value={this.state.myBrands
                      .filter((item) => {
                        return this.state.selectedBrand.includes(item.guid);
                      })
                      .map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })}
                  />
                  <CustomSelect.MyCustomSelect
                    placeholder={"MSKUs"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      this.state.mySkus
                        ? this.state.mySkus.sort(compare).map((item) => ({
                          value: item.Code,
                          label: item.Description,
                        }))
                        : []
                    }
                    onChange={this.handleSkus}
                    value={this.state.mySkus
                      .filter((item) => {
                        return this.state.selectedSku.includes(item.Code);
                      })
                      .map((item) => {
                        return {
                          value: item.Code,
                          label: item.Description,
                        };
                      })}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Region"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      regions
                        ? regions.sort(compare).map((item) => ({
                          value: item.guid,
                          label: item.Name,
                        }))
                        : []
                    }
                    onChange={this.handleRegion}
                    value={regions
                      .filter((item) => {
                        return this.state.selectedRegion.includes(item.guid);
                      })
                      .map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })}
                  />
                  <CustomSelect.MyCustomSelect
                    placeholder={"Core Type"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      coretype
                        ?
                        coretype.map((item) => {
                          return item !== '0' && item !== 'not available' && item !== 'Coretype not available' && {
                            value: item,
                            label: item
                          }
                        })
                        : []
                    }
                    onChange={this.handleCoreType}
                    value={coretype
                      .filter((item) => {
                        return this.state.selectedCoreType.includes(item);
                      })
                      .map((item) => {
                        return {
                          value: item,
                          label: item,
                        }
                      })}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Year"}
                    className="select-box"
                    options={this.state.years}
                    onChange={this.handleYear}
                    value={this.state.selectedYear}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Standpoint"}
                    className="select-box"
                    // allowSelectAll={true}
                    // isMulti
                    options={(standpoints && this.state.selectedYear)
                      ? standpoints[this.state.selectedYear[0].value].map((item) => ({
                        value: item,
                        label: item,
                      }))
                      : []}
                    onChange={this.handleStandPoint}
                    value={(standpoints && this.state.selectedYear) ? standpoints[this.state.selectedYear[0].value]
                      .filter((item) => {
                        return this.state.selectedStandPoint.includes(item);
                      })
                      .map((item) => {
                        return {
                          value: item,
                          label: item,
                        };
                      })
                      :
                      null
                    }
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Select"}
                    className="select-box"
                    // allowSelectAll={true}
                    // isMulti
                    options={this.state.graphType}
                    onChange={this.hanldeGrapgType}
                    value={this.state.selectedGraphType}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Machine"}
                    className="select-box"
                    // allowSelectAll={true}
                    // isMulti
                    options={[{ value: "Human", label: "Human Intervened" }, { value: "Machine", label: "Machine" }]}
                    onChange={this.handleIntervention}
                    value={this.state.selectedIntervention}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Select Type"}
                    className="select-box"
                    // allowSelectAll={true}
                    // isMulti
                    options={this.state.reportType}
                    onChange={this.reportTypehandle}
                    value={this.state.selectedReportType}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Activated/Not-Activated"}
                    className="select-box-type"
                    // allowSelectAll={true}
                    // isMulti
                    options={[{ value: 1, label: 'Activated' }, { value: 2, label: 'Non-Activated' }, { value: 3, label: 'All' }]}
                    onChange={this.handledActiveStatus}
                    value={this.state.selectedActiveStatus}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Volume"}
                    className="select-box"
                    options={this.state.isVolumeOptions}
                    onChange={this.hanldeIsVolume}
                    value={this.state.selectedIsVolume}
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Volume"}
                    className="select-box"
                    options={this.state.cutsOptions.map(item=>{
                      return {
                        label: item,
                        value: item
                      }
                    })}
                    onChange={this.handleCutChange}
                    value={
                      this.state.cutsOptions && this.state.selectedCut
                      ?
                      this.state.cutsOptions
                      .filter(item=>{
                        return this.state.selectedCut === item
                      })
                      .map(item=>{
                        return {
                          label: item,
                          value: item
                        }
                      })
                      :
                      []
                    }
                  />

                </div>
                <Button
                  variant="outlined"
                  className="submit-btn"
                  onClick={this.handleCallSubmit}
                >
                  SUBMIT
              </Button>
              </div>
              {this.state.currentSelectedType[0].label === 'Weekly' &&
                <WeeklyReport
                  // dummyData={dummyData.weeklyResponse} />}
                  dummyData={forecastReportAccuracy.length > 0 ? forecastReportAccuracy : forecastReportAccuracy} />}
              {this.state.currentSelectedType[0].label === 'Monthly' && <MonthlyReport
                dummyData={forecastReportAccuracy.length > 0 ? forecastReportAccuracy : forecastReportAccuracy} />}
              {/* dummyData={dummyData.monthlyResponse} />} */}
              {this.state.currentSelectedType[0].label === 'YTD' && <YTDReport
                dummyData={Object.keys(forecastReportAccuracy).length > 0 ? forecastReportAccuracy : forecastReportAccuracy} selectedYear={this.state.selectedYear} />}
              {/* />} */}
            </div>
          </div>
        </>
      );
    }

  }
}
const mapStateToProps = (state) => {
  return {
    isForcastAccuracyLoading:
      state.ForcastReportReducer.isForcastAccuracyLoading,
    category: state.CategoryReducer.category,
    forecastReportAccuracy: state.ForcastReportReducer.forcastAccuracy,
    isCategoryLoading: state.CategoryReducer.isCategoryLoading,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    segment: state.SegmentReducer.segment,
    regions: state.RegionReducer.regions,
    coretype: state.CoreTypeReducer.coretypes,
    standpoints: state.StandPointReducer.standpoints,
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    postForcastAccuracyV2Analytics: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedReportType,
      selectedGraphType,
      selectedYear,
      selectedCoreType,
      selectedStandPoint,
      selectedIntervention,
      selectedActiveStatus,
      selectedIsVolume,
      selectedCut,
      selectAllMSKU
    ) => {
      return dispatch(
        ForcastReportMiddleware.postForcastAccuracyV2Analytics(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectedReportType,
          selectedGraphType,
          selectedYear,
          selectedCoreType,
          selectedStandPoint,
          selectedIntervention,
          selectedActiveStatus,
          selectedIsVolume,
          selectedCut,
          selectAllMSKU
        )
      );
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getCoreType: () => {
      return dispatch(CoreTypeMiddleware.getCoreTypes())
    },
    getStandPoint: () => {
      return dispatch(StandPointMiddleware.getStandPoint())
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getSegment: () => {
      return dispatch(SegmentMiddleware.getSegment());
    },
    getRegions: () => {
      return dispatch(RegionsMiddleware.getRegions());
    },
    downloadXlx: (selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedReportType,
      selectedGraphType,
      selectedYear,
      selectedCoreType,
      selectedStandPoint,
      selectedIntervention,
      selectedActiveStatus,
      selectedIsVolume,
      selectedCut,
      selectAllMSKU) => {
      return dispatch(
        downloadFAFBreportMiddleware.downloadXlx(selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectedReportType,
          selectedGraphType,
          selectedYear,
          selectedCoreType,
          selectedStandPoint,
          selectedIntervention
          , selectedActiveStatus,
          selectedIsVolume,
          selectedCut,
          selectAllMSKU)
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToprops
)(ForecastAccuracyAnalyticsReport);
